import React from "react";

export default function StepTwo(props){
  const inputValues = props.inputValues

  let classNames = require('classnames');
  let headingClass = classNames({
    'col-sm-12 padding-top-15 padding-bottom-15 text-align-left body': !props.mobile,
    'col-sm-12 padding-10-0 text-align-left body': props.mobile
  });
  let rowClass = classNames({
    'row': !props.mobile,
    'row no-margin': props.mobile
  });

  return(
    <React.Fragment>
      <div className="step-breadcrumb hmcw-h5">Step 2 of 3</div>
      <div className="flex-justified padding-30-0">
        <div className="hmcw-h3" style={{textAlign:'left'}}>Tell me about your business</div>
      </div>
      <div className="form-group">
        <div className={rowClass}>
          <div className={headingClass} >Do you want to use RP Data for direct marketing?</div>
          <div className="col-xs-6 wizard-form-text body">
            <label className="wizard-form-radio">
              <input
                type="radio"
                name="directMarketing"
                value="Yes"
                checked={inputValues.directMarketing.value === "Yes"}
                onChange={props.handleChange} />
              Yes
            </label>
          </div>
          <div className="col-xs-6 wizard-form-text body">
            <label className="wizard-form-radio">
              <input
                type="radio"
                name="directMarketing"
                value="No"
                checked={inputValues.directMarketing.value === "No"}
                onChange={props.handleChange} />
              No
            </label>
          </div>
        </div>
        {
          inputValues.directMarketing.error &&
          <div className="red-text footnote-text hmcw-error-msg">Please answer yes or no this question.</div>
        }
      </div>
      <div className="form-group">
        <div className={rowClass}>
          <div className={headingClass}>Would you like to produce custom RP Data reports branded with your logo, colours and contact details?</div>
          <div className="col-xs-6 wizard-form-text body">
            <label className="wizard-form-radio">
              <input
                type="radio"
                name="dataReports"
                value="Yes"
                checked={inputValues.dataReports.value === "Yes"}
                onChange={props.handleChange} />
              Yes
            </label>
          </div>
          <div className="col-xs-6 wizard-form-text body">
            <label className="wizard-form-radio">
              <input
                type="radio"
                name="dataReports"
                value="No"
                checked={inputValues.dataReports.value === "No"}
                onChange={props.handleChange} />
              No
            </label>
          </div>
        </div>
        {
          inputValues.dataReports.error &&
          <div className="red-text footnote-text hmcw-error-msg">Please answer yes or no this question.</div>
        }
      </div>
    </React.Fragment>
  );
}
